/**
 * The only two values the client needs, and the reason the anon key is safe to
 * ship: row level security is complete (Section 12). Nothing else from the
 * environment belongs in a bundle.
 */
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? '';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

/** Pre-filled WhatsApp deep links go here. Set when Tim confirms the number. */
export const HOSTS_WHATSAPP = import.meta.env.VITE_HOSTS_WHATSAPP ?? '';

export const isConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
